import { EmptyStateWrapper } from "./styles";
import { EmptyStateProps } from "./types";

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  action,
  icon,
}) => {
  return (
    <EmptyStateWrapper>
      {icon && <div className="icon">{icon}</div>}
      <h3>{title}</h3>
      <p>{description}</p>
      {action && <div className="action">{action}</div>}
    </EmptyStateWrapper>
  );
};
